import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { shareReplay, catchError } from 'rxjs/operators';

import { Role } from '@app/models/role.enum';
import { User } from '@app/models/user-data';
import { ILink } from '@app/models/links';
import { ssoAuthRedirectUrl } from '@app/constants/auth-constants';
import { AppConfigService } from '@app/services/app-config.service';

import { LocalStorageItem } from '../auth.constants';
import { TokenService } from './token.service';
import { AuthDOS } from './auth-dos.service';
import { AuthRepoService } from './auth-repo.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private _tokenService: TokenService,
    private _authRepoService: AuthRepoService,
    private _authDOS: AuthDOS,
    private _appConfigService: AppConfigService
  ) {}

  getUserData(): Observable<User | undefined> {
    return this._authRepoService.getUserData().pipe(
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      }),
      shareReplay(1)
    );
  }

  updateCache(): Observable<undefined> {
    return this._authRepoService.updateCache();
  }

  getConstants(): Observable<ILink[]> {
    return this._authRepoService.getConstants();
  }

  signIn(): void {
    window.location.replace(this._appConfigService.config.authUrl.concat(ssoAuthRedirectUrl));
  }

  signOut(): void {
    localStorage.removeItem(LocalStorageItem.IsLogged);
    this._tokenService.deleteTokens();
    this._authDOS.updateUser(null);
    this._authDOS.setAuthTokenFalse();
    this.signIn();
  }

  isActive = () => {
    return !!this._authDOS.getUserSnapshot()?.userRole;
  };

  isAuthorized = (allowedRoles: Array<Role>) => {
    const user = this._authDOS.getUserSnapshot();
    if (user?.userRole && allowedRoles) {
      return allowedRoles.includes(user.userRole);
    }
    return true;
  };

  isAdmin = () => {
    return this._authDOS.getUserSnapshot()?.userRole === Role.Admin;
  };
}
